import Button from "react-bootstrap/Button";
import styles from "./EditUser.module.css";
import Modal from "react-bootstrap/Modal";
import { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";

function ChangePasswordModal({ show, setShow, token }) {
  const handleClose = () => setShow(false);
  const [actualPassword, setActualPassword] = useState("");
  const [newPassword1, setNewPassword1] = useState("");
  const [newPassword2, setNewPassword2] = useState("");
  const [message, setMessage] = useState("");
  const updatedSuccesfully = () =>
    toast.info("Your password has been updated!");
  const updatepassword = async () => {
    try {
      const response = await axios({
        url: `${process.env.REACT_APP_API_URL}/users`,
        method: "PATCH",
        headers: { Authorization: `Bearer ${token}` },
        data: {
          actualPassword,
          newPassword1,
          newPassword2,
        },
      });
      if (response) {
        handleClose();
        updatedSuccesfully();
      }
    } catch (error) {
      console.log(error);
      setMessage(error.response.data.msg);
    }
  };
  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header className={styles.modal} closeButton>
        <Modal.Title className={styles.modalTitle}>Change Password</Modal.Title>
      </Modal.Header>
      <Modal.Body className={styles.modal}>
        <div className="mb-3 row">
          <label
            htmlFor="actualPassword"
            className={"col-sm-6 col-form-label text-white " + styles.label}
          >
            Enter your password
          </label>
          <div className="col-sm-6">
            <input
              type="password"
              className={"form-control " + styles.inputpass}
              id="actualPassword"
              value={actualPassword}
              name="actualPassword"
              onChange={(event) => setActualPassword(event.target.value)}
            />
          </div>
        </div>
        <div className="mb-3 row">
          <label
            htmlFor="newPassword1"
            className={"col-sm-6 col-form-label text-white " + styles.label}
          >
            Enter new password
          </label>
          <div className="col-sm-6">
            <input
              type="password"
              className={"form-control " + styles.inputpass}
              id="newPassword1"
              value={newPassword1}
              name="newPassword1"
              onChange={(event) => setNewPassword1(event.target.value)}
            />
          </div>
        </div>
        <div className="mb-3 row">
          <label
            htmlFor="newPassword2"
            className={"col-sm-6 col-form-label text-white " + styles.label}
          >
            Confirm new password
          </label>
          <div className="col-sm-6">
            <input
              type="password"
              className={"form-control " + styles.inputpass}
              id="newPassword2"
              value={newPassword2}
              name="newPassword2"
              onChange={(event) => setNewPassword2(event.target.value)}
            />
          </div>
        </div>
        <p className="text-danger py-2">{message}</p>
      </Modal.Body>
      <Modal.Footer className={styles.modal}>
        <Button className={styles.modal_button} onClick={handleClose}>
          Close
        </Button>
        <Button className={styles.modal_button} onClick={updatepassword}>
          Update Password
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
export default ChangePasswordModal;
